import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { XFlowGroupCommands } from '../constant';
import { Disposable } from '../../common/disposable';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFLOW_GROUP_DEFAULT_COLLAPSED_SIZE } from '../../constants';
export var NsCollapseGroup;
(function (NsCollapseGroup) {
    NsCollapseGroup.command = XFlowGroupCommands.COLLAPSE_GROUP;
    NsCollapseGroup.hookKey = 'collapseGroup';
})(NsCollapseGroup || (NsCollapseGroup = {}));
let CollapseGroupCommand = 
/** 添加子节点命令 */
class CollapseGroupCommand {
    constructor() {
        this.toggleVisible = (cells, visible, graph) => {
            cells.forEach(cell => {
                const view = graph.findViewByCell(cell).container;
                view.style.visibility = visible ? 'visible' : 'hidden';
            });
        };
        this.toggleCollapse = (groupNode, graph, args) => {
            const childrens = groupNode.getChildren().filter(n => n.isNode());
            const groupData = groupNode.getData();
            const { isCollapsed, gap = 0 } = args;
            if (isCollapsed) {
                const collapsedSize = args.collapsedSize || groupData.groupCollapsedSize || XFLOW_GROUP_DEFAULT_COLLAPSED_SIZE;
                groupNode.prop('previousSize', groupNode.size());
                groupNode.size(collapsedSize);
            }
            else {
                groupNode.size(groupNode.prop('previousSize'));
            }
            if (childrens) {
                childrens.forEach(item => {
                    const position = groupNode.position();
                    const innerEdges = graph.getConnectedEdges(item).filter(edge => {
                        const sourceNode = edge.getSourceNode();
                        const targetNode = edge.getTargetNode();
                        return childrens.includes(sourceNode) && childrens.includes(targetNode);
                    });
                    if (isCollapsed) {
                        this.toggleVisible([item, ...innerEdges], false, graph);
                        item.prop('previousSize', item.size());
                        item.prop('previousRelativePosition', item.position({ relative: true }));
                        item.position(position.x + gap, position.y + gap);
                        const size = groupNode.size();
                        item.size({
                            width: size.width - gap * 2,
                            height: size.height - gap * 2,
                        });
                    }
                    else {
                        this.toggleVisible([item, ...innerEdges], true, graph);
                        const pos = item.prop('previousRelativePosition');
                        const size = item.prop('previousSize');
                        item.position(pos.x, pos.y, { relative: true });
                        item.size(size);
                    }
                });
            }
            groupNode.prop('isCollapsed', isCollapsed);
            groupNode.setData(Object.assign(Object.assign({}, groupNode.getData()), { isCollapsed }));
        };
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.collapseGroup.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const x6Graph = yield this.ctx.getX6Graph();
                const node = x6Graph.getCellById(args.nodeId);
                const { toggleService } = handlerArgs;
                if (toggleService) {
                    const canToggle = yield toggleService(handlerArgs);
                    if (!canToggle)
                        return { err: 'service rejected' };
                }
                if (node) {
                    this.toggleCollapse(node, x6Graph, args);
                    this.ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                        if (node) {
                            this.toggleCollapse(node, x6Graph, Object.assign(args, { isCollapsed: !args.isCollapsed }));
                        }
                    })));
                }
                return { err: null };
            }), runtimeHook);
            this.ctx.setResult(result);
            return this;
        });
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], CollapseGroupCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CollapseGroupCommand.prototype, "init", null);
CollapseGroupCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsCollapseGroup.command.id },
    })
    /** 添加子节点命令 */
], CollapseGroupCommand);
export { CollapseGroupCommand };
//# sourceMappingURL=group-toggle-collapse.js.map